import { render, staticRenderFns } from "./PerfilUsuario.vue?vue&type=template&id=edd9f720&scoped=true"
import script from "./PerfilUsuario.vue?vue&type=script&lang=js"
export * from "./PerfilUsuario.vue?vue&type=script&lang=js"
import style0 from "./PerfilUsuario.vue?vue&type=style&index=0&id=edd9f720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd9f720",
  null
  
)

export default component.exports